<template>
  <div>
    <el-form class="form" :inline="true" :model="queryInfo">
      <el-row :gutter="24" style="padding-left: 12px; margin-bottom: -10px">
        <el-form-item label="所属电站">
          <el-select
            v-model="xuanzedianzhan"
            placeholder="请选择电站"
            @change="sousuo"
            filterable
            @clear="getPowerStationList"
            clearable
          >
            <el-option
              v-for="item in station_list_all"
              :key="item.stationId"
              :label="item.stationName"
              :value="item.stationId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电桩编号">
          <el-input
            placeholder="请输入电桩编号"
            v-model="queryInfo.pileCode"
            @change="current"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="电桩类型：">
          <el-select
            v-model="queryInfo.pileType"
            placeholder="请选择电桩类型"
            @change="pileTyping"
            filterable
            @clear="getPowerStationList"
            clearable
          >
            <el-option
              v-for="item in pileType_list"
              :key="item"
              :label="
                item == 0
                  ? '锐创直流桩'
                  : item == 1
                  ? '锐创交流桩'
                  : item == 2
                  ? '无疆(二代)交流桩'
                  : item == 3
                  ? '光法(一代)直流桩'
                  : item == 4
                  ? '光法(一代)交流桩'
                  : item == 5
                  ? '锐创低速桩'
                  : item == 6
                  ? '交直流桩'
                  : ''
              "
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通讯状态：">
          <el-select
            v-model="queryInfo.commStatus"
            placeholder="请选择通讯状态"
            @change="tongxun"
            filterable
            @clear="getPowerStationList"
            clearable
          >
            <el-option
              v-for="item in tongxun_list"
              :key="item"
              :label="
                item == 0
                  ? '已下线'
                  : item == 1
                  ? '很好'
                  : item == 2
                  ? '正常'
                  : item == 3
                  ? '一般'
                  : item == 4
                  ? '很差'
                  : ''
              "
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工作状态：" v-if="zhuangkuang">
          <el-select
            v-model="queryInfo.gunState"
            placeholder="请选择工作状态"
            @change="leixing"
            filterable
            @clear="getPowerStationList"
            clearable
          >
            <el-option
              v-for="item in gongzuo_list"
              :key="item"
              :label="
                item == 0
                  ? '空闲中'
                  : item == 1
                  ? '准备开始充电'
                  : item == 2
                  ? '充电进行中'
                  : item == 3
                  ? '充电结束'
                  : item == 4
                  ? '启动失败'
                  : item == 5
                  ? '预约状态'
                  : item == 6
                  ? '系统故障'
                  : item == 7
                  ? '升级中'
                  : ''
              "
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车连接状态：" v-if="zhuangkuang">
          <el-select
            v-model="queryInfo.gunToCarState"
            placeholder="请选择车连接状态"
            @change="leixings"
            filterable
            @clear="getPowerStationList"
            clearable
          >
            <el-option
              v-for="item in car_list"
              :key="item"
              :label="
                item == 0
                  ? '断开'
                  : item == 1
                  ? '半连接'
                  : item == 2
                  ? '连接'
                  : ''
              "
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="电桩描述" v-if="roleType">
          <el-input v-model="queryInfo.pileSketch"></el-input>
        </el-form-item>
        <el-form-item label="服务器类型" v-if="roleType">
          <el-select
            v-model="queryInfo.serverType"
            placeholder="请选择服务器类型"
            filterable
            clearable
            @clear="getPowerStationList"
          >
            <el-option
              v-for="(item, index) in serverTypeList"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="check_event"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-refresh-left"
            @click="chongzhi"
            >重置</el-button
          >
          <el-button @click="typeMethods">更多</el-button>
        </el-form-item>
        <!-- <el-form-item>
            <el-button @click="changePile">切换新版</el-button>
          </el-form-item> --> </el-row
      ><!--</el-col> -->
    </el-form>
    <!-- 二维码 -->
    <el-dialog
      title="二维码"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
    >
      <div id="rccode">
        <h4
          style="
            display: flex;
            justify-content: center;
            font-weight: bolder;
            color: #000;
          "
        >
          链接地址： <span>{{ url }}</span>
        </h4>
        <div style="display: flex; justify-content: center">
          <div class="content" ref="captureArea" style="width: 250px">
            <div class="codetu" style="color: #000; padding: 20px 25px">
              <VueQr :text="url" v-if="dialogVisible"></VueQr>
            </div>
            <div
              class="list"
              style="
                display: flex;
                justify-content: center;
                font-weight: bolder;
                color: #000;
              "
              :style="{
                fontSize: type == 5 ? '30px' : '18px',
              }"
            >
              {{ dianzhuanghao }}
            </div>
          </div>
        </div>
        <div
          slot="footer"
          class="dialog-footer"
          style="
            display: flex;
            justify-content: center;
            margin-right: 5%;
            margin-top: 30px;
          "
        >
          <el-button type="success" @click="capture">下载图片</el-button>
          <el-button type="info" @click="handleClose">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 桩启动 -->
    <el-dialog
      title="充电桩桩启动"
      :visible.sync="tanceng"
      width="40%"
      :before-close="clearMethods"
    >
      <div id="oile">
        <el-form v-model="clearForm">
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="clearForm.phone" style="width: 200px"></el-input>
          </el-form-item>
          <el-form-item label="小程序" prop="appId">
            <el-select v-model="clearForm.appId" filterable clearable>
              <el-option
                v-for="(item, index) in applist"
                :key="index"
                :value="item.id"
                :label="item.appname"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启动方式" prop="userAny">
            <el-select v-model="clearForm.userAny" filterable clearable>
              <el-option
                v-for="(item, index) in userAnylist"
                :key="index"
                :value="item.userAny"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="启动来源" prop="tag">
            <el-radio-group v-model="clearForm.tag">
              <el-radio v-for="item in leaavel" :key="item" :label="item">{{
                item == 1 ? '微信' : '支付宝'
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <div
          class="footer"
          style="display: flex; flex-direction: row; justify-content: flex-end"
        >
          <el-button @click="clearMethods" type="error">取消</el-button>
          <el-button @click="pileMethods" type="success">确定</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 卡片视图区域 -->
    <el-card class="card">
      <li
        style="
          display: flex;
          flex-direction: row;
          justify-content: flex-end;
          margin: -10px 0 10px -1%;
        "
      >
        <el-button
          v-if="tianjiadianzhaung"
          type="success"
          icon="el-icon-plus"
          @click="showElePile"
          >添加电桩</el-button
        >
        <el-button
          v-if="shanchu"
          type="danger"
          icon="el-icon-delete"
          @click="removeById"
          >批量删除</el-button
        >
        <el-button
          v-if="piliangqianyi"
          icon="el-icon-document-copy"
          @click="qianyiMethods"
          >批量迁移</el-button
        >
        <el-button icon="el-icon-upload2" v-if="daoru" @click="importElePile"
          >导入电桩</el-button
        >
        <el-button icon="el-icon-download" v-if="daochu" @click="exportElePile"
          >导出电桩</el-button
        >
      </li>
      <!-- table表格区域 -->
      <el-table
        class="table"
        :data="elePileList"
        border
        stripe
        @selection-change="handleSelectionChange"
        empty-text="暂无数据"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        ></el-table-column>
        <!-- <el-table-column align="center" label="ID" prop="id"></el-table-column> -->
        <el-table-column align="center" label="桩序号" prop="pileNo" width="55">
          <template slot-scope="scope">
            <span>{{ scope.row.pileNo ? scope.row.pileNo : 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="电桩编号"
          prop="pileCode"
          width="150"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.pileCode }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="枪号"
          prop="gunNumber"
          width="70"
        >
          <template slot-scope="scope">
            <el-tag
              v-model="scope.row.gunNumber"
              v-if="scope.row.pileType !== 5"
              :type="stylecss(scope.row.gunNumber)"
              >{{ name(scope.row.gunNumber) }}</el-tag
            >
            <el-tag v-model="scope.row.gunNumber" v-else type="warning">{{
              name(scope.row.gunNumber)
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="设备类型"
          prop="deviceTypeName"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.deviceTypeName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="电站名称"
          prop="stationName"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.stationName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          v-if="MenuRole"
          label="电桩描述"
          prop="pileSketch"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.pileSketch }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="工作状态"
          prop="runStateName"
          width="90"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.gunState == '0'
                  ? 'info'
                  : scope.row.gunState == '1'
                  ? ''
                  : scope.row.gunState == '2'
                  ? 'success'
                  : 'warning'
              "
              v-model="scope.row.gunState"
              v-if="
                scope.row.gunState == '0' ||
                scope.row.gunState == '1' ||
                scope.row.gunState == '2' ||
                scope.row.gunState == '3' ||
                scope.row.gunState == '4' ||
                scope.row.gunState == '5' ||
                scope.row.gunState == '6' ||
                scope.row.gunState == '7' ||
                scope.row.gunState == '8' ||
                scope.row.gunState == '9'
              "
              >{{ scope.row.runStateName }}</el-tag
            >
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="通讯状态"
          prop="communicationStatusName"
          width="72"
        >
          <template slot-scope="scope">
            <el-tag
              type="info"
              v-model="scope.row.commStatus"
              v-if="scope.row.commStatus == '0'"
              >{{ scope.row.communicationStatusName }}</el-tag
            >
            <el-tag
              type="success"
              v-model="scope.row.commStatus"
              v-if="scope.row.commStatus == '1'"
              >{{ scope.row.communicationStatusName }}</el-tag
            >
            <el-tag
              v-model="scope.row.commStatus"
              v-if="scope.row.commStatus == '2'"
              >{{ scope.row.communicationStatusName }}</el-tag
            >
            <el-tag
              type="warning"
              v-model="scope.row.commStatus"
              v-if="scope.row.commStatus == '3'"
              >{{ scope.row.communicationStatusName }}</el-tag
            >
            <el-tag
              type="danger"
              v-model="scope.row.commStatus"
              v-if="scope.row.commStatus == '4'"
              >{{ scope.row.communicationStatusName }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="车连接"
          prop="carStateName"
          width="72"
        >
          <template slot-scope="scope">
            <el-tag
              type="info"
              v-model="scope.row.gunToCarState"
              v-if="scope.row.gunToCarState == '0'"
              >{{ scope.row.carStateName }}</el-tag
            >
            <el-tag
              type="warning"
              v-model="scope.row.gunToCarState"
              v-if="scope.row.gunToCarState == '1'"
              >{{ scope.row.carStateName }}</el-tag
            >
            <el-tag
              type="success"
              v-model="scope.row.gunToCarState"
              v-if="scope.row.gunToCarState == '2'"
              >{{ scope.row.carStateName }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column align="left" label="告警信息" prop="alarm" width="130">
          <template slot-scope="scope" style="display: flex; flex-wrap: wrap">
            <span>{{ scope.row.alarm }}</span>
          </template>
        </el-table-column>
        <!-- sortable="custom"
          :sort-method="sortMethod" -->
        <el-table-column align="center" label="SIM" prop="sim" width="100">
          <template slot-scope="scope">
            <span
              style="color: #6b7280"
              v-if="
                typeSlice(scope.row) == '--' ||
                typeSlice(scope.row) == '未获取到sim卡' ||
                typeSlice(scope.row) == '00000000000000000000'
              "
            >
              {{ typeSlice(scope.row) }}
            </span>
            <p v-else>
              <button
                @click="cilsTable(scope.row)"
                v-if="
                  !scope.row.expirationTime || scope.row.expirationTime == ''
                "
              >
                SIM卡
              </button>
              <button
                v-else
                @click="cilsTable(scope.row)"
                :style="{
                  color:
                    scope.row.expirationTime < 30 ||
                    scope.row.expirationTime == 30
                      ? 'red'
                      : scope.row.expirationTime < 60 ||
                        scope.row.expirationTime == 60
                      ? 'orange'
                      : scope.row.expirationTime > 60
                      ? 'green'
                      : scope.row.expirationTime == 0
                      ? 'red'
                      : '#6B7280',
                }"
                style="font-weight: bolder"
              >
                {{ scope.row.expirationTime }}天
              </button>
            </p>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
          prop="pileState"
          width="70"
        >
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.pileState"
              :active-color="
                scope.row.pileState == true ? '#ff4949' : '#13ce66'
              "
              :inactive-color="
                scope.row.pileState == true ? '#ff4949' : '#13ce66'
              "
              @change="change_pileState(scope.row)"
              :disabled="zhuangtai_quanxian"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="更新时间"
          prop="updateTime"
          width="100"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.updateTime }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="状态" width="80" v-else>
          <template>
            <el-switch align="center" v-model="zhuangtai" inactive-text="禁用" style="padding-left: 25px;"
              disabled></el-switch>
          </template>
        </el-table-column> -->
        <el-table-column align="left" label="操作" fixed="right">
          <template slot-scope="scope">
            <p>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-edit"
                @click="showElePile(scope.row)"
                v-if="bianji && MenuRole"
                >编辑</el-button
              >
              <el-button
                size="mini"
                icon="el-icon-refresh"
                type="warning"
                @click="chongqi(scope.row)"
                v-if="
                  (chongqi_btn && MenuRole && scope.row.pileType == 0) ||
                  (chongqi_btn && scope.row.pileType == 1)
                "
                :disabled="scope.row.c_q_anniu"
                >重启</el-button
              >
              <!-- <el-button size="mini" type="danger" @click="removeById(scope.row)" v-if="caozuoquanxian">删除</el-button> -->
              <el-button
                size="mini"
                icon="el-icon-picture"
                @click="shezhierweima(scope.row)"
                >显示二维码</el-button
              >
            </p>
            <p>
              <!-- <el-button size="mini" disabled v-if="caozuoquanxian">推送</el-button> -->
              <el-button
                size="mini"
                v-if="MenuRole"
                @click="dianzhuangrizhi(scope.row)"
                :disabled="scope.row.d_z_r_z_anniu"
                >电桩日志</el-button
              >
              <el-button
                size="mini"
                v-if="scope.row.serverType == 1"
                @click="downCode(scope.row)"
                >下发二维码</el-button
              >
              <el-button
                size="mini"
                v-if="quanxian2"
                @click="startUser(scope.row)"
                >用户启动</el-button
              >
            </p>
          </template>
        </el-table-column>
      </el-table>
      <!-- 添加&编辑电桩的对话框 -->
      <el-dialog
        :title="title"
        :visible.sync="elePileVisible"
        width="35%"
        append-to-body
        :close-on-click-modal="false"
      >
        <!-- 内容主体区域 -->
        <el-form
          :model="elePileForm"
          :rules="elePileRules"
          ref="elePileRef"
          label-width="95px"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="电桩编号" prop="pileCode">
                <el-input
                  v-model="elePileForm.pileCode"
                  :disabled="title == '编辑电桩'"
                  placeholder="请输入电桩编号"
                  style="width: 100%"
                  @change="changing"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="桩序号" prop="pileNo">
                <el-input v-model="elePileForm.pileNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="充电枪" v-if="title === '编辑电桩'">
                <el-select
                  v-model="elePileForm.gunNumber"
                  disabled
                  placeholder="请选择充电枪"
                  filterable
                >
                  <el-option
                    v-for="item in gunOptions"
                    :key="item"
                    :label="item == 1 ? 'A枪' : item == 2 ? 'B枪' : ''"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="充电枪" v-else>
                <el-select
                  v-model="elePileForm.gunNumber"
                  placeholder="请选择充电枪"
                  filterable
                >
                  <el-option
                    v-for="item in gunOptions"
                    :key="item"
                    :label="item == 1 ? '单枪' : item == 2 ? '双枪' : ''"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="功率Kw" prop="pilePower">
                <el-select
                  v-model="elePileForm.pilePower"
                  placeholder="请选择电桩功率"
                  filterable
                >
                  <el-option
                    v-for="item in chapOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属电站" prop="stationId">
                <el-select
                  v-model="elePileForm.stationId"
                  placeholder="请选择所属电站"
                  @change="change_station"
                  filterable
                >
                  <el-option
                    v-for="item in station_list"
                    :key="item.stationId"
                    :label="item.stationName"
                    :value="item.stationId"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="额定电流A" prop="pileCurrent">
                <el-select
                  v-model="elePileForm.pileCurrent"
                  placeholder="请选择电桩功率"
                  filterable
                >
                  <el-option
                    v-for="item in chapOptions2"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="电桩类型" prop="pileType">
                <el-select
                  v-model="elePileForm.pileType"
                  placeholder="请选择电桩类型"
                  filterable
                  @change="cueewntMethods"
                >
                  <el-option
                    v-for="item in devtOptions"
                    :key="item"
                    :label="
                      item == 0
                        ? '锐创直流桩'
                        : item == 1
                        ? '锐创交流桩'
                        : item == 2
                        ? '无疆(二代)交流桩'
                        : item == 3
                        ? '光法(一代)直流桩'
                        : item == 4
                        ? '光法(一代)交流桩'
                        : item == 5
                        ? '锐创低速桩'
                        : ''
                    "
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="充电类型" prop="pileClassType">
                <el-select
                  v-model="elePileForm.pileClassType"
                  placeholder="请选择充电类型"
                  filterable
                >
                  <el-option
                    v-for="item in chatOptions"
                    :key="item"
                    :label="
                      item == 0
                        ? '慢充'
                        : item == 1
                        ? '快充'
                        : item == 2
                        ? '低速'
                        : item == 3
                        ? '超充'
                        : ''
                    "
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="限定充电" prop="limitType">
                <el-select
                  v-model="elePileForm.limitType"
                  placeholder="请选择通讯方式"
                  filterable
                >
                  <el-option
                    v-for="item in limitTypeOptions"
                    :key="item"
                    :label="
                      item == 0
                        ? '全部允许'
                        : item == 1
                        ? '禁止小程序用户'
                        : item == 2
                        ? '禁止电卡用户'
                        : item == 4
                        ? '禁止小程序和电卡用户'
                        : item == 3
                        ? '禁止Vin用户'
                        : item == 5
                        ? '禁止小程序和Vin用户'
                        : item == 6
                        ? '禁止电卡和Vin用户'
                        : ''
                    "
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="通讯方式" prop="netType">
                <el-select
                  v-model="elePileForm.netType"
                  placeholder="请选择通讯方式"
                  filterable
                >
                  <el-option
                    v-for="item in comTypeOptions"
                    :key="item"
                    :label="
                      item == 0
                        ? '4G路由'
                        : item == 1
                        ? '以太网'
                        : item == 2
                        ? 'DTU'
                        : ''
                    "
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="主控类型" prop="motherboardClass">
                <el-select
                  v-model="elePileForm.motherboardClass"
                  placeholder="请选择主控类型"
                  filterable
                >
                  <el-option
                    v-for="item in motherboardClassOptions"
                    :key="item.paramKey"
                    :label="item.paramValue"
                    :value="item.paramKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="设备简述" prop="pileSketch">
                <el-input
                  v-model="elePileForm.pileSketch"
                  placeholder="请输入设备简述"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="服务器类型" prop="serverType">
                <el-select
                  v-model="elePileForm.serverType"
                  placeholder="请选择主控类型"
                  filterable
                >
                  <el-option
                    v-for="(item, index) in serverTypeOptions"
                    :key="index"
                    :label="item == 0 ? 'Gateway' : 'Netty'"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="协议类型" prop="protocolClass">
                <el-select
                  v-model="elePileForm.protocolClass"
                  placeholder="请选择协议类型"
                  filterable
                >
                  <el-option
                    v-for="item in protocolClassOptions"
                    :key="item.paramKey"
                    :label="item.paramValue"
                    :value="item.paramKey"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 底部按钮区域 -->
        <span slot="footer" class="dialog-footer">
          <el-button @click="qx1">取 消</el-button>
          <el-button type="primary" @click="editElePile">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 导入电桩列表 -->
      <el-dialog
        title="导入"
        :visible.sync="importDialogVisible"
        width="660px"
        :close-on-click-modal="false"
        :before-close="onClose"
        @closed="onAfterClose"
      >
        <div v-loading="loading" class="dialog-content">
          <el-form ref="formRef" :model="formData" label-width="80px">
            <el-form-item label="选择文件" prop="fileList">
              <el-upload
                ref="upload"
                action="#"
                :accept="extAcceptStr"
                :auto-upload="false"
                :limit="limit"
                :file-list="formData.fileList"
                :on-change="onFileChange"
                :on-remove="onFileMove"
                :on-exceed="onFileExceed"
              >
                <div class="select-file">
                  <p class="select-p">请选择上传文件</p>
                  <el-button size="small" type="primary">选取文件</el-button>
                </div>
                <div slot="tip" class="el-upload__tip">
                  {{ `支持${extAcceptStr} 格式的文件，大小不能超过10M` }}
                </div>
              </el-upload>
              <!-- <el-button type="text" @click="onDownload">模板下载</el-button> -->
            </el-form-item>
          </el-form>
        </div>
        <template slot="footer">
          <el-button
            type="primary"
            :loading="!!loading"
            :disabled="!formData.fileList.length > 0"
            @click="onSubmit"
            >导入
          </el-button>
          <el-button @click="importDialogVisible = false">取消</el-button>
        </template>
      </el-dialog>
      <!-- 分页导航区域 -->
      <el-pagination
        @size-change="changesize"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[8, 20, 50, 100]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 迁移电桩 -->
      <el-dialog title="批量迁移电桩" :visible.sync="qianyiAdress" width="30%">
        <el-select
          v-model="qianyidianzhuang"
          clearable
          placeholder="请选择迁往电站"
          @change="qianyi_station"
          filterable
        >
          <el-option
            v-for="item in station_list_listall"
            :key="item.stationId"
            :label="item.stationName"
            :value="item.stationId"
          >
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="qinyidizhi3">取 消</el-button>
          <el-button type="primary" @click="qinyidizhi2">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 电桩日志 -->
      <el-dialog
        title="电桩日志"
        :visible.sync="rizhi"
        width="50%"
        :close-on-click-modal="false"
        :before-close="quxiao"
        @closed="quxiao"
      >
        <div class="table">
          <el-table
            :data="tableData"
            stripe
            style="width: 100%"
            empty-text="暂无数据"
          >
            <el-table-column prop="pileIpAddr" label="登录IP" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.pileIpAddr }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="threadId" label="连接线程" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.threadId }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="pileCode" label="登陆桩号" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.pileCode }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="loginTime"
              label="上线时间"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.loginTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="loginOutTime"
              label="离线时间"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{
                  scope.row.loginOutTime != null ? scope.row.loginOutTime : '--'
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="loginState" label="登录状态" align="center">
              <template slot-scope="scope">
                <el-tag
                  :type="
                    scope.row.loginState == '1'
                      ? 'info'
                      : scope.row.loginState == '0'
                      ? 'success'
                      : ''
                  "
                  v-model="scope.row.loginState"
                  >{{
                    scope.row.loginState == '1'
                      ? '离线'
                      : scope.row.loginState == '0'
                      ? '成功'
                      : ''
                  }}</el-tag
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handlesize"
            @current-change="handleCurrent"
            :current-page="rizi.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="rizi.limit"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total_all"
            background
          >
          </el-pagination>
        </div>
      </el-dialog>
    </el-card>

    <el-dialog
      title="SIM卡信息"
      :visible.sync="TableDialoag"
      width="20vw"
      :close-on-click-modal="false"
      :before-close="onClose1"
    >
      <div>
        <p>Sim卡号：{{ objj.sim }}</p>
        <p v-if="!objj.expirationTime || objj.expirationTime == ''">厂家未知</p>
        <p
          v-else
          :style="{
            color:
              objj.expirationTime < 30 || objj.expirationTime == 30
                ? 'red'
                : objj.expirationTime < 60 || objj.expirationTime == 60
                ? 'orange'
                : objj.expirationTime > 60
                ? 'green'
                : objj.expirationTime == 0
                ? 'red'
                : '#6B7280',
          }"
          style="font-weight: bolder"
        >
          <span> 剩余{{ objj.newCanUse }}M流量 </span>
          <span> / {{ objj.expirationTime }}天</span>
        </p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveBlobToFile } from '@/utils/saveBlobToFile'
import VueQr from '../VueQr.vue'
import caozuo from '@/utils/pubilc.js'
import html2canvas from 'html2canvas'
import axios from 'axios'
export default {
  name: 'elePileWorld',
  components: {
    VueQr,
  },
  props: {
    loading: Boolean,
    limit: {
      //限制文件上传个数
      type: Number,
      default: 1,
    },
  },
  data() {
    // 电桩编号的校验规则
    const checkpileCode = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9]+$/
      if (reg.test(value)) {
        return callback()
      }
      callback(new Error('电桩编号由数字、字母或者或者其中一种组成'))
    }
    return {
      roleType: window.sessionStorage.getItem('roleId') == 1 ? true : false,
      serverTypeOptions: [0, 1],
      leaavel: [1, 2],
      quanxian2: false,
      clearForm: {
        tag: 1,
        userAny: 0,
        appId: '',
        stationId: '',
        gunNumber: '',
        pileCode: '',
        serverType: '',
        pileType: '',
        phone: '',
        money: null,
      },
      MenuRole:
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
          ? true
          : false,
      car_list: [0, 1, 2],
      defaultType: false,
      autosize: false,
      yincang: true,
      daochu: 162,
      zhuangkuang: false,
      bianji: false,
      chongqi_btn: false,
      tianjiadianzhaung: false,
      shanchu: false,
      piliangqianyi: false,
      daoru: false,
      pileType_list: ['0', '1', '2', '3', '4', '5', '6'],
      tongxun_list: [0, 1, 2, 3, 4],
      gongzuo_list: [0, 1, 2, 3, 4, 5, 6, 7],
      limitTypeOptions: [0, 1, 2, 4, 3, 5, 6],
      motherboardClassOptions: [],
      zhuangtai: false,
      qianghao: '',
      dianzhuanghao: '',
      url: '',
      codeText: '',
      dialogVisible: false,
      dianzhuangrizhi_disabled: false,
      ids4: 0,
      xuanzedianzhan: null,
      code: null,
      pageSize_all: 0,
      total_all: 100,
      currentPage3: 0,
      tableData: [],
      rizhi: false,
      newstationIds: null,
      qianyiAdress: false,
      qianyidianzhuang: '',
      // # config
      extAccept: ['xls', 'xlsx'],
      // # state
      importDialogVisible: false,
      // # data
      formData: {
        fileList: [],
      },
      applist: [],
      userAnylist: [
        {
          userAny: 0,
          name: '正常余额',
        },
        {
          userAny: 1,
          name: '即充即退',
        },
        {
          userAny: 2,
          name: '绑定金额',
        },
      ],
      // 查询所有电桩列表的参数
      queryInfo: {
        pileCode: '',
        stationIds: null,
        gunState: null,
        commStatus: null,
        page: 1,
        limit: 8,
        pileType: null,
        stationMode: '0,1',
        roleId: window.sessionStorage.getItem('roleId'),
        gunToCarState: '',
        pileSketch: null,
        serverType: null,
      },
      rizi: {
        pileCode: null,
        startTime: null,
        endTime: null,
        page: 1,
        limit: 10,
      },
      serverTypeList: [
        {
          value: 0,
          label: 'PHP',
        },
        {
          value: 1,
          label: 'Netty',
        },
      ],
      total: 0,
      // 枪号数据
      gunOptions: [1, 2],
      // 功率数据
      chapOptions: [
        {
          value: 0,
          label: 0,
        },
        {
          value: 7,
          label: 7,
        },
        {
          value: 11,
          label: 11,
        },
        {
          value: 14,
          label: 14,
        },
        {
          value: 20,
          label: 20,
        },
        {
          value: 22,
          label: 22,
        },
        {
          value: 30,
          label: 30,
        },
        {
          value: 40,
          label: 40,
        },
        {
          value: 60,
          label: 60,
        },
        {
          value: 80,
          label: 80,
        },
        {
          value: 120,
          label: 120,
        },
        {
          value: 140,
          label: 140,
        },
        {
          value: 160,
          label: 160,
        },
        {
          value: 180,
          label: 180,
        },
        {
          value: 200,
          label: 200,
        },
        {
          value: 240,
          label: 240,
        },
        {
          value: 260,
          label: 260,
        },
        {
          value: 300,
          label: 300,
        },
        {
          value: 320,
          label: 320,
        },
        {
          value: 360,
          label: 360,
        },
        {
          value: 400,
          label: 400,
        },
        {
          value: 480,
          label: 480,
        },
        {
          value: 600,
          label: 600,
        },
        {
          value: 640,
          label: 640,
        },
        {
          value: 800,
          label: 800,
        },
        {
          value: 960,
          label: 960,
        },
        {
          value: 1280,
          label: 1280,
        },
      ],
      // 功率数据
      chapOptions2: [32, 64, 65, 80, 150, 200, 250, 300, 400, 600],
      // 充电类型
      chatOptions: ['0', '1', '2', '3'],
      // 电桩类型
      devtOptions: [0, 1, 2, 3, 4, 5],
      stationName: [],
      comTypeOptions: [0, 1, 2],
      // 车连接状态
      carOptions: [
        {
          label: '断开',
          value: 0,
        },
        {
          label: '半连接',
          value: 1,
        },
        {
          label: '连接',
          value: 2,
        },
      ],
      // 电桩列表及参数
      elePileList: [],
      page_num: 0,
      page_num1: 0,
      elePileForm: {
        id: null,
        pileCode: null,
        stationId: null,
        gunNumber: null,
        pilePower: null,
        pileClassType: null,
        pileType: null,
        netType: 0,
        pileSketch: null,
        pileState: null,
        limitType: 0,
        pileGl: '',
        protocolClass: 0,
        motherboardClass: 0,
        serverType: 0,
        pileCurrent: null,
        pileNo: 0,
      },
      elePileRules: {
        pileCode: [
          { required: true, message: '电桩编号不能为空', trigger: 'blur' },
          { validator: checkpileCode, trigger: 'blur' },
        ],
        stationId: [
          { required: true, message: '请至少选择一项', trigger: 'change' },
        ],
        gunNumber: [
          { required: true, message: '请至少选择一项', trigger: 'change' },
        ],
        pilePower: [
          { required: true, message: '请至少选择一项', trigger: 'change' },
        ],
        pileClassType: [
          { required: true, message: '请至少选择一项', trigger: 'change' },
        ],
        pileType: [
          { required: true, message: '请至少选择一项', trigger: 'change' },
        ],
        netType: [
          { required: true, message: '请至少选择一项', trigger: 'change' },
        ],
        pileSketch: [
          { required: false, message: '请至少选择一项', trigger: 'change' },
        ],
      },
      type: '',
      ids1: 0,
      ids2: 0,
      ids3: 0,
      elePileVisible: false,
      title: '',
      value: '',
      shows: false,
      pileNumbers: null,
      ids: '',
      powerStation: [],
      canshu: {},
      checked_all: '',
      station_list: [],
      station_list_listall: [],
      station_list_all: [],
      protocolClassOptions: [],
      caozuoquanxian: false,
      gunState: null,
      commStatus: null,
      zhuangtai_quanxian: false,
      tanceng: false,
      objj: {
        newCanUse: '',
        expirationTime: '',
        sim: '',
      },
      TableDialoag: false,
    }
  },
  computed: {
    name() {
      return (obj) => {
        const obj1 = {
          1: 'A枪',
          2: 'B枪',
          3: 'C枪',
          4: 'D枪',
          5: 'E枪',
          6: 'F枪',
          7: 'G枪',
          8: 'H枪',
          9: 'I枪',
          10: 'J枪',
          11: 'K枪',
          default: '其他枪',
        }
        return obj1[obj]
      }
    },
    stylecss() {
      return (obj) => {
        const obj1 = {
          1: 'primary',
          2: 'success',
          3: 'warning',
          4: 'danger',
        }
        return obj1[obj]
      }
    },
    typeSlice() {
      return (obj) => {
        if (!obj || !obj.sim || obj.sim == '') return '--'
        if (obj.sim == '00000000000000000000') return '未获取到sim卡'
      }
    },
    extAcceptStr() {
      return this.extAccept.map((ext) => `.${ext}`).join(',')
    },
  },
  watch: {
    'queryInfo.stationIds': {
      handler(newValue) {
        if (newValue == null) {
          this.queryInfo.stationIds =
            window.sessionStorage.getItem('stationIds')
        } else {
          this.queryInfo.stationIds = newValue
        }
      },
    },
  },
  created() {
    const that = this
    that.zhuangtai_quanxian =
      window.sessionStorage.getItem('roleId') == 1 ? false : true
    // caozuo(170).then(res => {
    //   that.zhuangtai_quanxian = res;
    // });
    caozuo(156).then((res) => {
      that.bianji = res
    })
    caozuo(156).then((res) => {
      that.quanxian2 = res
    })
    caozuo(162).then((res) => {
      that.daochu = res
    })
    caozuo(95).then((res) => {
      that.chongqi_btn = res
    })
    caozuo(159).then((res) => {
      that.tianjiadianzhaung = res
    })
    caozuo(157).then((res) => {
      that.shanchu = res
    })
    caozuo(158).then((res) => {
      that.daoru = res
    })
    caozuo(160).then((res) => {
      that.piliangqianyi = res
    })
    that.getPowerStationList()
    that.$http.get('/sysConfig/getSysConfigById/68').then((resb) => {
      that.motherboardClassOptions = JSON.parse(resb.data.data.valueName)
      that.motherboardClassOptions.forEach(
        (item) => (item.paramKey = item.paramKey * 1)
      )
    })
    that.$http.get('/sysConfig/getSysConfigById/69').then((rese) => {
      that.protocolClassOptions = JSON.parse(rese.data.data.valueName)
      that.protocolClassOptions.forEach(
        (item) => (item.paramKey = item.paramKey * 1)
      )
    })
  },
  methods: {
    cilsTable(el) {
      const { newCanUse, expirationTime, sim } = el
      this.objj = {
        newCanUse,
        expirationTime,
        sim,
      }
      this.TableDialoag = !this.TableDialoag
    },
    startUser(el) {
      console.log(el, '854')
      const { stationId, serverType, gunNumber, pileCode, pileType } = el
      this.clearForm.stationId = stationId
      this.clearForm.serverType = serverType
      this.clearForm.gunNumber = gunNumber
      this.clearForm.pileCode = pileCode
      this.clearForm.pileType = pileType
      // this.$http
      //   .get('station-info/getStationInfoById/' + stationId)
      //   .then((res) => {
      //     const { parkType } = res.data.data;
      //     this.clearForm.parkType = parkType;
      this.$http
        .get('applet/getAllAppletApp', {
          params: {
            adminId: window.sessionStorage.getItem('adminId'),
            page: 1,
            limit: 150,
          },
        })
        .then((res1) => {
          if (res1.code > 0) return this.$message.error('小程序数据丢失')
          const { code, data } = res1.data
          this.applist = data
          this.tanceng = true
        })
      // })
    },
    pileMethods() {
      const that = this
      let bindmoney = 0
      let money = 0
      let QuciklyMoney = 0
      const { phone, appId, tag, userAny } = that.clearForm
      if (!phone || phone == '') {
        that.$message.error('请输入用户启动的手机号！')
        return
      }

      if (!appId || appId == '') {
        that.$message.error('请选择小程序！')
        return
      }
      // https://testdzlapi.cpolar.top/
      that.$http
        .get('charge-user-info/getAllNewChargeUserInfo', {
          params: {
            appId,
            phone,
            adminId: window.sessionStorage.getItem('adminId'),
            roleId: window.sessionStorage.getItem('roleId'),
            page: 1,
            limit: 6,
            type: 0,
            stationMode: '0,1,2',
          },
        })
        .then((ress) => {
          if (ress.data.code > 0 || !ress.data.data)
            return that.$message.error(
              '该小程序并无此手机号,请检查您输入的手机号是否有误！'
            )
          if (ress.data.data.length == 0)
            return that.$message.error(
              '该小程序并无此手机号,请检查您输入的手机号是否有误！'
            )
          const { wxOpenId, alipayId } = ress.data.data[0]
          console.log(ress.data, ress.data.data, 1703)
          const acc = window.sessionStorage.getItem('开发模式') == 'PROD'
            ? 'https://dzlapi.rcdqiot.com/'
            : 'https://testdzlapi.cpolar.top/'
          const abc = {
            1: `app-charge-user-info/getAppChargeUserInfoById/${wxOpenId}`,
            2: `alipay_chargeUserInfo/getAppChargeUserInfoById/${alipayId}`,
          }
          axios.get(acc + abc[that.clearForm.tag]).then((res1) => {
            console.log(res1.data, 1705)
            const { bindingStationMoneylist, cardsType } = res1.data.data
            // clearForm.stationId
            const acn = bindingStationMoneylist.filter((item) => {
              return item.stationId == that.clearForm.stationId
            })
            bindmoney = acn && acn.length > 0 ? acn[0].money : 0
            money = res1.data.data.money
            QuciklyMoney = res1.data.data.prepaidMoney
            that.qidong(bindmoney, money, QuciklyMoney, cardsType)
          })
        })
    },
    qidong(bindmoney, money, QuciklyMoney, cardsType) {
      const that = this
      const { userAny, serverType } = that.clearForm;
      that.clearForm.money=userAny==0?money:userAny==1?QuciklyMoney:bindmoney;
      if (serverType > 0) {
        if (userAny !== 0) {
          that.clearForm.userAny = userAny == 1 ? 2 : 3
        } else {
          that.clearForm.userAny = cardsType !== 0 ? 1 : 0
        }
      }
      if (!that.clearForm.money || that.clearForm.money == '' || that.clearForm.money == 0) {
          that.$message.error('用户启动余额错误，请选择其他充电方式！')
          return
        }
        that.clearForm.money=Number(that.clearForm.money);
      that.$http.post('pileInfo/startCharge', that.clearForm).then((res1) => {
        const { code, data } = res1.data
        that.$message({
          type: code > 0 ? 'error' : 'success',
          message: code > 0 ? data : '充电桩启动成功！',
        })
        if (code == 0) {
          that.clearMethods()
        }
      })
    },
    clearMethods() {
      this.tanceng = false
      this.clearForm.phone = ''
      this.clearForm.appId = ''
      this.clearForm.tag = 1
    },
    // netty 下发二维码
    downCode(row) {
      this.$base
        .post(`remoteCharge/sendQr`, {
          pileCode: row.pileCode,
          adminName: window.sessionStorage.getItem('trueName'),
        })
        .then((res) => {
          if (res.data.code > 200) return this.$message.error('下发二维码错误')
          this.$message.success('下发二维码成功')
        })
    },
    // sim卡排序
    sortMethod(a, b) {
      console.log(a.sim, '818')
    },
    // 二维码图片下载
    capture() {
      html2canvas(this.$refs.captureArea, {
        useCORS: true, // 处理跨域图片
        logging: false, // 关闭日志
        scale: 2, // 提高分辨率
      }).then((canvas) => {
        const link = document.createElement('a')
        link.href = canvas.toDataURL('image/png')
        link.download = this.dianzhuanghao + '.png'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
    },
    // 更多搜索条件
    typeMethods() {
      this.zhuangkuang = !this.zhuangkuang
    },
    // 桩类型切换
    cueewntMethods() {
      this.elePileForm.lowerLimits =
        this.elePileForm.pileType == 0 ||
        this.elePileForm.pileType == 3 ||
        this.elePileForm.pileType == null ||
        this.elePileForm.pileType == undefined ||
        this.elePileForm.pileType == ''
          ? null
          : 32
      this.elePileForm.upperLimits =
        this.elePileForm.pileType == 0 || this.elePileForm.pileType == 3
          ? this.elePileForm.upperLimits
          : null
    },
    // 新、旧版切换
    changePile() {
      this.$emit('fatherMethod', 1)
    },
    chunkArray(array, chunkSize) {
      return Array.from(
        { length: Math.ceil(array.length / chunkSize) },
        (v, i) => array.slice(i * chunkSize, i * chunkSize + chunkSize)
      )
    },
    // 电桩编号是否重复：判断
    changing() {
      const that = this
      that.$http
        .get(`pileInfo/getPileInfoCodeById/${that.elePileForm.pileCode}`)
        .then((res) => {
          if (res.data.code > 0) {
            that.$message.error('电桩编号已存在')
            that.elePileForm.pileCode = ''
          }
        })
    },
    // 编辑的取消按钮；
    qx1() {
      this.$refs.elePileRef.resetFields()
      this.elePileVisible = false
      this.elePileForm = {}
      this.elePileList.forEach((item) => {
        if (item.id == this.ids1) {
          item.b_j_anniu = false
        }
      })
    },
    // 下载图片：取消
    handleClose() {
      this.dialogVisible = false
      this.url = ''
      this.dianzhuanghao = ''
    },
    zhanshi() {
      this.yincang = !this.yincang
    },
    // 重启
    async chongqi(e) {
      this.ids2 = e.id
      e.c_q_anniu = true
      const confirmResult = await this.$confirm(
        '此操作将重启, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      if (confirmResult !== 'confirm') {
        e.c_q_anniu = false
        this.$message.info('已取消重启！')
      } else {
        if (e.serverType == 0) {
          // gateWay
          this.$http
            .get(
              `pileInfo/Restart/${e.pileCode}/${Number(
                window.sessionStorage.getItem('adminId')
              )}`
            )
            .then((res) => {
              this.$message({
                type: res.data.code > 0 ? 'error' : 'success',
                message: res.data.msg,
              })
              e.c_q_anniu = false
            })
        } else {
          // Netty
          this.$base
            .post(`remoteCharge/restart`, {
              pileCode: e.pileCode,
              adminName: window.sessionStorage.getItem('trueName'),
            })
            .then((res) => {
              this.$message({
                type: res.data.code > 200 ? 'error' : 'success',
                message: res.data.msg,
              })
              e.c_q_anniu = false
            })
        }
      }
    },
    // 加载更多
    jizaigengduo() {
      this.zhuangkuang = !this.zhuangkuang
    },
    // 改变电桩状态
    async change_pileState(row) {
      const { data: res } = await this.$http.post(
        'pileInfo/updateStateByPileCode',
        {
          pileCode: row.pileCode,
          pileState: row.pileState,
        }
      )
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('编辑电桩成功！')
      this.check_event()
      this.elePileVisible = false
    },
    // 重置搜索条件
    chongzhi() {
      this.queryInfo = {
        pileCode: null,
        stationIds: null,
        gunState: null,
        commStatus: null,
        page: 1,
        limit: 8,
        pileType: null,
        stationMode: '0,1',
        roleId: window.sessionStorage.getItem('roleId'),
        gunToCarState: '',
        pileSketch: null,
        serverType: null,
      }
      this.xuanzedianzhan = null
      this.getPowerStationList()
    },
    // 获取电站列表
    async getPowerStationList() {
      const that = this
      that.elePileList = []
      that.queryInfo.stationIds = !that.queryInfo.stationIds
        ? window.sessionStorage.getItem('stationIds')
        : that.queryInfo.stationIds
      let objs = {
        pileCode: that.queryInfo.pileCode,
        stationIds: that.queryInfo.stationIds,
        gunState: that.queryInfo.gunState,
        commStatus: that.queryInfo.commStatus,
        page: that.queryInfo.page,
        limit: that.queryInfo.limit,
        pileType:
          that.queryInfo.pileType == null
            ? '0,1,2,3,4,5'
            : that.queryInfo.pileType == 6
            ? '0,1,2,3,4'
            : that.queryInfo.pileType,
        roleId: that.queryInfo.roleId,
        gunToCarState: that.queryInfo.gunToCarState,
        pileSketch: that.queryInfo.pileSketch,
        serverType: that.queryInfo.serverType,
      }
      console.log(that.queryInfo.serverType, 1356)
      if (!that.queryInfo.serverType || that.queryInfo.serverType == '') {
        that.$delete(objs, 'serverType')
      }
      let abc = {
        roleId: window.sessionStorage.getItem('roleId'),
        stationIds: window.sessionStorage.getItem('stationIds'),
        stationMode: '0,1',
      }
      if (
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
      ) {
        if (!that.xuanzedianzhan || that.xuanzedianzhan == '') {
          that.$delete(objs, 'stationIds')
          that.$delete(abc, 'stationIds')
        }
      }
      console.log(objs, '984')
      that.$http
        .get('pileInfo/getAllPileInfo', {
          params: objs,
        })
        .then((res) => {
          if (res.data.code == 0) {
            that.elePileList = res.data.data
            that.elePileList.forEach((item) => {
              item.b_j_anniu = false
              item.c_q_anniu = false
              item.d_z_r_z_anniu = false
            })
            that.total = res.data.count
          }
        })
      that.station_list_all = []
      that.station_list = []
      await that.$http
        .get('station-info/getAllStationInfoName', {
          params: abc,
        })
        .then((resb) => {
          resb.data.data.forEach((item) => {
            that.station_list.push({
              stationId: item.id,
              stationName: item.stationName,
            })
            that.station_list_all.push({
              stationId: item.id,
              stationName: item.stationName,
            })
          })
        })
    },
    // 搜索
    sousuo(e) {
      this.queryInfo.page = 1
      this.queryInfo.stationIds = e
    },
    current() {
      this.queryInfo.page = 1
    },
    // 工作状态
    leixing(e) {
      this.queryInfo.page = 1
      this.queryInfo.gunState = e
    },
    // 车连接状态状态
    leixings(e) {
      this.queryInfo.page = 1
      this.queryInfo.gunToCarState = e
    },
    // 电桩类型
    pileTyping(e) {
      this.queryInfo.page = 1
      this.queryInfo.pileType = e
      this.getPowerStationList()
    },
    // 通讯状态
    tongxun(e) {
      this.queryInfo.page = 1
      this.queryInfo.commStatus = e
    },
    // 复选框选择事件
    async check_event() {
      this.elePileList = []
      this.queryInfo.page = 1
      this.queryInfo.stationIds == null
        ? window.sessionStorage.getItem('stationIds')
        : this.xuanzedianzhan
      this.getPowerStationList()
    },
    // 改变电站
    change_station(e) {
      this.queryInfo.stationIds = e
    },
    // 设置二维码
    shezhierweima(row) {
      this.ids3 = row.id
      this.type = row.pileType
      this.url = row.qrCodeType == 0 ? row.qrCode : row.publicQrCode
      this.dianzhuanghao =
        row.pileType == 5 ? row.pileCode : row.pileCode + row.gunNumberName
      setTimeout(() => {
        this.dialogVisible = true
      }, 1000)
    },
    // 改变页码
    handleCurrent(newPage) {
      this.rizi.page = newPage
      // 页码跳跃
      this.public_function()
    },
    // 改变数据条数
    handlesize(newSize) {
      this.rizi.limit = newSize
      this.rizi.page = 1
      // 页码跳跃
      this.public_function()
    },
    quxiao() {
      this.rizhi = false
      this.rizi.page = 1
      this.rizi.limit = 10
      this.elePileList.forEach((item) => {
        if (item.id == this.ids4) {
          item.d_z_r_z_anniu = false
        }
      })
    },
    public_function() {
      this.rizi.pileCode = this.code
      this.$http
        .get('pile-login-log/getAllPileLoginLog', {
          params: this.rizi,
        })
        .then((resb) => {
          this.total_all = resb.data.count
          this.tableData = resb.data.code !== 0 ? [] : resb.data.data
          this.rizhi = resb.data.code !== 0 ? false : true
          this.dianzhuangrizhi_disabled = resb.data.code !== 0 ? true : false
          if (resb.data.code !== 0) {
            this.$message.error('暂无电桩日志')
          }
          this.dianzhuangrizhi_disabled = false
          // if (val == 1) {
          //   this.total_all = resb.data.count;
          //   this.pageSize_all = Math.ceil(this.total_all / 5);
          //   console.log(this.pageSize_all, 'this.pageSize_all');
          // }
        })
    },
    async dianzhuangrizhi(row) {
      this.ids4 = row.id
      if (this.currentPage3 == 0) {
        this.currentPage3 = 1
      }
      this.code = row.pileCode
      // this.$store.commit('del', window.sessionStorage.getItem('activePath'));
      // this.$store.commit('luyou', {
      //   url: 'EletricPileLog',
      //   menuname: '电桩日志'
      // });
      // window.sessionStorage.setItem('activePath', 'EletricPileLog');
      // this.$store.commit('commitMethods', 'ted');
      // this.$router.push({ path: '/EletricPileLog', query: { code: row.pileCode } });
      // this.$store.commit('runAway',)
      this.public_function()
      this.public_function(this.currentPage3)
    },
    qianyi_station(e) {
      this.newstationIds = e
    },
    qinyidizhi2() {
      this.$http
        .post(
          '/pileInfo/updPileInfoStationId?ids=' +
            this.ids +
            '&stationId=' +
            this.newstationIds +
            '&adminId=' +
            Number(window.sessionStorage.getItem('adminId'))
        )
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.msg)
          } else {
            this.$message.error(res.data.msg)
          }
          this.qianyiAdress = false
          this.getPowerStationList()
        })
    },
    qinyidizhi3() {
      this.qianyidianzhuang = ''
      this.qianyiAdress = false
    },
    qianyiMethods() {
      const that = this
      that.station_list_listall = []
      let abc = {
        roleId: window.sessionStorage.getItem('roleId'),
        stationIds: window.sessionStorage.getItem('stationIds'),
        stationMode: '0,1',
      }
      if (
        window.sessionStorage.getItem('roleId') == 1 ||
        window.sessionStorage.getItem('roleId') == 2 ||
        window.sessionStorage.getItem('roleId') == 3 ||
        window.sessionStorage.getItem('roleId') == 10
      ) {
        if (
          !that.qianyidianzhuang == null ||
          that.qianyidianzhuang == undefined ||
          that.qianyidianzhuang == ''
        ) {
          that.$delete(abc, 'stationIds')
        }
      }
      that.$http
        .get('station-info/getAllStationInfoName', {
          params: abc,
        })
        .then((res) => {
          if (res.data.code !== 0) return
          if (that.ids == null || that.ids == undefined || that.ids == '')
            return that.$message.error('请勾选需要迁移的电桩')
          res.data.data.forEach((item) => {
            that.station_list_listall.push({
              stationId: item.id,
              stationName: item.stationName,
            })
          })
          that.qianyiAdress = true
        })
    },
    importElePile() {
      this.importDialogVisible = true
    },
    onClose() {
      this.importDialogVisible = false
    },
    onClose1() {
      this.TableDialoag = false
      this.objj = {
        expirationTime: '',
        sim: '',
        newCanUse: '',
      }
    },
    onAfterClose() {
      this.formData = {
        fileList: [],
      }
    },
    // # upload
    // 校验
    validateFile(file) {
      if (!file) return '至少添加一个文件！'
      const ext = (file.name || '').split('.')[1]
      if (!this.extAccept.includes(ext))
        return `仅支持${this.extAcceptStr}格式的文件`
      return ''
    },
    // 选择文件的改变事件
    onFileChange(file, fileList) {
      const errMsg = this.validateFile(file)
      if (errMsg) {
        this.$message.error(errMsg)
        this.formData.fileList.splice(0, 1)
      } else {
        this.formData.fileList = fileList
      }
    },
    onFileMove(file, fileList) {
      this.formData.fileList = fileList
    },
    onFileExceed() {
      this.$message.error(`仅允许上传 ${this.limit} 个文件！`)
    },
    // # emit
    // 模板下载
    // async onDownload() {
    //   const { data: res } = await this.$http.get('chargingPile/exportExcel/' + 2940, { responseType: 'blob' })
    //   saveBlobToFile(res, '电桩模板')
    //   if (res.data.code != 0) {
    //     this.$message.error(res.msg)
    //   }
    //   this.$message.success(res.msg)
    // },
    // 导入
    async onSubmit() {
      var formData = new FormData()
      for (const file of this.formData.fileList) {
        //多个文件全部都放到files
        if (file.raw) {
          formData.append('file', file.raw)
          formData.append(
            'adminId',
            window.sessionStorage.getItem('adminId') * 1
          )
        }
      }
      const { data: res } = await this.$http.post(
        'pileInfo/importPileInfo',
        formData
      )
      this.importDialogVisible = false
      if (res.data.code != 0) {
        this.$message.error(res.msg)
        this.check_event()
      } else {
        this.$message.success(res.msg)
      }
    },
    changesize(newSize) {
      this.queryInfo.limit = newSize
      this.queryInfo.page = 1
      this.getPowerStationList()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getPowerStationList()
    },
    // 展示添加&编辑电桩对话框
    async showElePile(row) {
      this.elePileVisible = true
      this.ids1 = row.id
      // this.$store.commit('del', window.sessionStorage.getItem('activePath'));
      // this.$store.commit('luyou', {
      //   url: 'ElectricPileAdd',
      //   menuname: '电桩编辑'
      // });
      // window.sessionStorage.setItem('activePath', 'ElectricPileAdd');
      // this.$router.push({
      //   name: 'ElectricPileAdd',
      //   params: {
      //     id: row.id
      //   }
      // })
      if (row.id === undefined || row.id === null || row.id === '') {
        this.title = '添加电桩'
        this.gunOptions = [1, 2]
      } else {
        this.title = '编辑电桩'
        this.shows = true
        this.gunOptions = [1, 2]
        const { data: resb } = await this.$http.get(
          'pileInfo/getPileInfoById/' + row.id
        )
        if (resb.code !== 0) {
          row.b_j_anniu = false
          this.$message.error(resb.msg)
        } else {
          row.b_j_anniu = true
          this.elePileForm = resb.data
          if (resb.data.stationName == null) {
            this.elePileForm.stationName = '暂无电站名称'
          } else {
            this.elePileForm.stationName = resb.data.stationName
          }
        }
      }
    },
    // 添加&编辑电桩提交事件
    editElePile() {
      this.$refs.elePileRef.validate(async (valid) => {
        if (!valid) return
        const { pileCode, pileNo } = this.elePileForm
        if (!pileCode || pileCode == '')
          return this.$message.error('电桩编号为必传项')
        if (pileNo && pileNo !== 0) {
          this.$http
            .post(`pileInfo/updatePileNo/${pileCode}/${pileNo}`)
            .then((ress) => {
              const { code } = ress.data
              if (code !== 0) return this.$message.error('桩编号错误！')
              this.cill()
            })
          return
        }
        this.cill()
      })
    },
    async cill() {
      this.elePileForm.adminId = window.sessionStorage.getItem('adminId') * 1
      console.log(this.elePileForm, '1249')

      if (this.title == '添加电桩') {
        const { data: res } = await this.$http.post(
          'pileInfo/addPileInfo',
          this.elePileForm
        )
        if (res.code !== 0) return this.$message.error(res.msg)
        this.$message.success('添加电桩成功！')
        this.check_event()
        this.elePileVisible = false
        this.qingkongMethods()
        return
      }
      this.elePileForm.state === true
        ? this.elePileForm.state === 0
        : this.elePileForm.state === 1
      const { data: res } = await this.$http.post(
        'pileInfo/updPileInfo',
        this.elePileForm
      )
      if (res.code !== 0) return this.$message.error(res.msg)
      this.$message.success('编辑电桩成功！')
      this.check_event()
      this.elePileVisible = false
      this.qingkongMethods()
    },
    qingkongMethods() {
      this.elePileForm = {
        id: null,
        pileCode: null,
        stationId: null,
        gunNumber: null,
        pilePower: null,
        pileClassType: null,
        pileType: null,
        netType: 0,
        pileSketch: null,
        pileState: null,
        limitType: 0,
        pileGl: '',
        protocolClass: 0,
        motherboardClass: 0,
        serverType: 0,
        pileCurrent: null,
        pileNo: 0,
      }
    },
    elePileDialogClosed() {
      this.shows = false
      this.$refs.elePileRef.resetFields()
    },
    // 删除电桩
    async removeById(row) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该电桩(*包含该桩号对应的所有枪号), 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).catch((err) => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }
      if (
        row.pileCode === null ||
        row.pileCode === '' ||
        row.pileCode === undefined
      ) {
        if (
          this.pileNumbers === null ||
          this.pileNumbers === '' ||
          this.pileNumbers === undefined
        )
          return this.$message.error('请选择你要删除的电桩编号')
        const { data: res } = await this.$http.post(
          'pileInfo/delPileInfoById/' +
            this.pileNumbers +
            '/' +
            Number(window.sessionStorage.getItem('adminId'))
        )
        if (res.code !== 0) {
          return this.$message.error('删除电桩失败！')
        }
        this.$message.success('删除电桩成功！')
        this.check_event()
      } else {
        const { data: res } = await this.$http.post(
          'pileInfo/delPileInfoById/' +
            row.pileCode +
            '/' +
            Number(window.sessionStorage.getItem('adminId'))
        )
        if (res.code !== 0) {
          return this.$message.error('删除电桩失败！')
        }
        this.$message.success('删除电桩成功！')
        this.check_event()
      }
    },
    // 批量删除的复选框选择事件
    handleSelectionChange(value) {
      if (value.length > 0) {
        this.ids = ''
        this.pileNumbers = ''
        console.log(value)
        const newValue = []
        const newPileNumbers = []
        value.forEach((item) => {
          newValue.push(item.id)
          newPileNumbers.push(item.pileCode)
        })
        Array.from(new Set(newValue)).forEach((item) => {
          this.ids += item + ','
        })
        Array.from(new Set(newPileNumbers)).forEach((item) => {
          this.pileNumbers += item + ','
        })
        // substring(index, array/string.length - n)
        //  n代表去掉后几位，index 从下标为index开始
        this.ids = this.ids.substring(0, this.ids.length - 1)
        console.log(this.ids, 'ids')
        this.pileNumbers = this.pileNumbers.substring(
          0,
          this.pileNumbers.length - 1
        )
        new Set()
        // 方法返回是一个类数组，需要结合 ...运算符或者Array.from()，转成真实数组
        // console.log([...new Set(newValue)]  === Array.from(new Set(newValue)))
      }
    },
    // 导出
    async exportElePile() {
      if (this.ids === '' || this.ids === null || this.ids === undefined) {
        this.$alert('电桩选择不能为空', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          callback: (action) => {
            this.$message({
              type: 'error',
              message: '请选择要导出的电桩！',
            })
          },
        })
      } else {
        const { data: res } = await this.$http.get(
          'pileInfo/exportExcel/' +
            this.ids +
            '/' +
            Number(window.sessionStorage.getItem('adminId')),
          { responseType: 'blob' }
        )
        saveBlobToFile(res, '电桩列表')
        if (res) {
          this.$message.success('文件导出成功')
        } else {
          this.$message.error('文件导出失败')
        }
      }
    },
  },
}
</script>
